import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const CookiesAndLogFiles = () => {
  return (
    <>
      <Subtitle>Cookies and Log Files</Subtitle>
      <Paragraph>
        Glints does not collect any personally identifiable information from you
        while you visit and browse the Site. When you access the Site, Glints
        records your visits only and does not collect your personal information
        or data. The Site’s server software will also record the domain name,
        server, address and track the pages you visit and store such information
        in “cookies”, and gather and store information such as internet protocol
        (IP) addresses, browser type, referring/exit pages, operating system,
        date/time stamp, and clickstream data in log files. All these are done
        without you being aware that they are occurring.
      </Paragraph>
      <Paragraph>
        You can choose to accept or decline cookies. Most web browsers
        automatically accept cookies, but you can modify their individual
        browser settings to decline cookies if they prefer. However, you should
        note that disabling cookies on their browser may prevent them from
        taking full advantage of the Site.
      </Paragraph>
      <Paragraph>
        Glints does not link the information and data automatically collected in
        the above manner to any personally identifiable information. Glints
        generally uses such automatically collected information and data to
        estimate the audience size of the Site, gauge the popularity of various
        parts of the Site, track your movements and number of entries in Glints’
        promotional activities and special events, measure traffic patterns and
        administer the Site. Such automatically collected information and data
        will not be disclosed save and except in accordance with the section
        headed “Disclosure or Transfer of Data“.
      </Paragraph>
      <Paragraph>
        In addition, our third party advertising companies may place cookies on
        some of the pages you visit on the Site. These cookies are designed to
        collect non-personally identifiable information in order to analyze your
        interests and searches on our Site to help deliver more relevant
        advertisements when you visit our Site. The non-personally identifiable
        information collected by these cookies may be shared with other third
        parties for the purpose of managing and targeting advertisements and for
        market research analysis.
      </Paragraph>
    </>
  );
};
